import { render, staticRenderFns } from "./ListTotauxApprovisionnements.vue?vue&type=template&id=472e77f8&"
import script from "./ListTotauxApprovisionnements.vue?vue&type=script&lang=ts&"
export * from "./ListTotauxApprovisionnements.vue?vue&type=script&lang=ts&"
import style0 from "./ListTotauxApprovisionnements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports